module.exports = __webpack_public_path__ + "img/clock.21d97150.png";